export class TranslationKeys {
    static DATA_SAVED = 'web.dataSavedSuccessfully';
    static REJECT_LESSEE_COMMENTS = 'web.rejectLesseeComments';
    static HORSE_LEASING = 'web.horseLeasing';
    static CONFIRM_MSG_REJECT_REQUEST = 'web.confirmMsgRejectrequest';
    static REJECT = 'web.reject';
    static HORSE = 'web.horse';
    static ORIGIN = 'web.origin';
    static BREEDER = 'web.breeder';
    static GENDER = 'web.gender';
    static COLOR = 'web.color';
    static BIRTH_DATE = 'web.birthDate';
    static SIRE = 'web.sire';
    static DAM = 'web.dam';
    static COVERING_CERTIFICATE_DETAILS = 'web.coveringCertificateDetails';
    static IS_HORSE_COVERED = 'web.isHorseCovered';
    static COVERING_CERTIFICATE_ID = 'web.coveringCertificateId';
    static STALLION = 'web.stallion';
    static LESSEE = 'web.lessee';
    static REQUIRED_FIELD = 'web.requiredField';
    static LEASE_DETAILS = 'web.leaseDetails';
    static LEASE_START_DATE = 'web.leaseStartDate';
    static LEASE_END_DATE = 'web.leaseEndDate';
    static LESSEE_PERMISSIONS = 'web.lesseePermissions';
    static IS_HORSE_LEASED = 'web.isHorseLeased';
    static LEASING_CONTRACT = 'web.leasingContract';
    static PARTICIPATE_IN_BEAUTY_SHOWS = 'web.participateInBeautyShows';
    static COVERING_AND_FOAL_REGISTRATION = 'web.coveringAndFoalRegistration';
    static REGISTER_FOALS_FOR_OTHER_OWNERS = 'web.registerFoalsForOtherOwners';
    static IMPORT_AND_EXPORT = 'web.importAndExport';
    static DOCUMENT = 'web.document';
    static DOCUMENT_TYPE = 'web.documentType';
    static SERVICE_REQUEST_DOCUMENT_TYPE = 'web.serviceRequestDocumentType';
    static OWNER_COMMENT = 'web.ownerComment';
    static LESSEE_COMMENT = 'web.lesseeComment';
    static COMMENT = 'web.comment';
    static EAHS_COMMENTS = 'web.eahsComments';
    static PLEASE_CHECK_ALL_TERMS = 'web.pleaseCheckAllTerms';
    static TERMS = 'web.terms';
    static UPLOAD_DOCUMENT = 'web.uploadDocument';
    static INVALID_DATE = 'web.invalidDate';
    static AT_LEAST_ONE_PERMISSION_REQUIRED = 'web.atLeastOneLesseePermissionIsRequired';

    // Covering & Semen
    static COVERING_DETAILS = 'web.coveringDetails';
    static COVERING_DATE = 'web.coveringDate';
    static TYPE_OF_COVERING = 'web.typeOfCovering';
    static ARTIFICIAL_INSEMINATION_LOCAL = 'web.artificialInseminationLocal';
    static FROZEN = 'web.Frozen';
    static SEMEN_OWNERSHIP_CERTIFICATE = 'web.semenOwnershipCertificate';
    static SEMEN_DOSE_OWNERSHIP_REFERENCE_NUMBER = 'web.semenDoseOwnershipReferenceNumber';
    static SELECT_COVERING_CERTIFICATE = 'web.selectCoveringCertificate';
    static COVERING_DATE_AFTER_STALLION_BIRTH = 'web.coveringDateAfterStallionBirth';

    // Stallion & Mare Details
    static STALLION_DETAILS = 'web.stallionDetails';
    static MARE_DETAILS = 'web.mareDetails';
    static REG_NO = 'web.regNo';
    static UELN = 'web.ueln';
    static OWNER_NAME = 'web.ownerName';
    static FIND_EXISTING_MARE = 'web.findExistingMare';
    static NAME = 'web.name';
    static HORSE_ADDRESS = 'web.horseAddress';
    static HORSE_COUNTRY = 'web.horseCountry';

    // UI & Feedback
    static LOADING = 'web.loading';
    static TYPE_TO_SEARCH = 'web.typeToSearch';
    static NO_OPTIONS = 'web.noOptions';
    static PLEASE_FILL_IN_ALL_FIELDS = 'web.pleaseFillInTheAllfields';
    static DOWNLOAD_CERTIFICATE = 'web.downloadCertificate';
    static EDIT = 'web.edit';
}
